import React, { useState } from "react";

type FilterStatus = "pending" | "approved" | "rejected";

interface StatusFilterProps {
  onChange: (value: FilterStatus) => void;
  defaultValue?: FilterStatus;
}

const FILTERS: FilterStatus[] = ["pending", "approved", "rejected"];

const StatusFilter: React.FC<StatusFilterProps> = ({
  onChange,
  defaultValue = "pending",
}) => {
  const [selected, setSelected] = useState<FilterStatus>(defaultValue);

  const handleSelect = (value: FilterStatus) => {
    setSelected(value);
    onChange(value);
  };

  return (
    <div className="flex items-center gap-3">
      {FILTERS.map((filter) => {
        const isActive = selected === filter;

        return (
          <button
            key={filter}
            onClick={() => handleSelect(filter)}
            className={`px-4 py-2 rounded-lg text-sm font-medium capitalize transition-all duration-200 border
              ${
                isActive
                  ? "bg-blue-600 text-white border-blue-600"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
              }`}
          >
            {filter}
          </button>
        );
      })}
    </div>
  );
};

export default StatusFilter;
